var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9395 3.00098C18.2805 3.00098 19.5705 3.53098 20.5195 4.48198C21.4695 5.43098 22.0005 6.71098 22.0005 8.05098V15.951C22.0005 18.741 19.7305 21.001 16.9395 21.001H7.06049C4.26949 21.001 2.00049 18.741 2.00049 15.951V8.05098C2.00049 5.26098 4.25949 3.00098 7.06049 3.00098H16.9395ZM18.5304 9.54131L18.6104 9.46131C18.8494 9.17131 18.8494 8.75131 18.5994 8.46131C18.4604 8.31231 18.2694 8.22131 18.0704 8.20131C17.8604 8.19031 17.6604 8.26131 17.5094 8.40131L13.0004 12.0013C12.4204 12.4823 11.5894 12.4823 11.0004 12.0013L6.50042 8.40131C6.18942 8.17131 5.75942 8.20131 5.50042 8.47131C5.23042 8.74131 5.20042 9.17131 5.42942 9.47131L5.56042 9.60131L10.1104 13.1513C10.6704 13.5913 11.3494 13.8313 12.0604 13.8313C12.7694 13.8313 13.4604 13.5913 14.0194 13.1513L18.5304 9.54131Z",
    fill: "#1A427D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailContact);
export default __webpack_public_path__ + "static/media/email-contact.5912a0c69d1928b571ce9f6472d8c757.svg";
export { ForwardRef as ReactComponent };